<style src="./styles.scss" lang="scss"></style>
<template>
  <div class="SerproAuthorize wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="mail-box">
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Setor</label>
            <div class="col-md-12">
              <select class="form-control" v-model="searchForm.park">
                <option value="">Todos</option>
                <option
                  v-for="(item, idx) in parkingList"
                  :key="idx"
                  :value="item.id"
                >
                  {{ item.parkName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Código</label>
            <input class="form-control" v-model="searchForm.creditCode" />
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Data Inicial</label>
            <input type="date" v-model.lazy="searchForm.dateStart"/>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <label class="col-md-12">Data Final</label>
            <input type="date" v-model.lazy="searchForm.dateEnd"/>
          </div>
        </div>
      </div>
      <div class="col-sm-1">
        <div class="form-group">
          <button
            @click="listGuardNotifications"
            type="submit"
            class="btn btn-block btn-primary compose-mail"
          >
            <i class="fa fa-search"></i>
            <i class="fa fa-spinner fa-spin" v-show="isExportSearchBusy"></i>
          </button>
        </div>
      </div>

    </div>
    
    <div class="row">
      <div class="mail-box">
        <table class="table table-hover table-mail">
          <thead class="table-head">
            <tr>
              <th class="licencePlate">Placa</th>
              <th class="createdAt">Data do Registro</th>
              <th class="code">Código</th>
              <th class="sector">Setor</th>
              <th class="amountPaid">Saldo Devedor</th>
              <th class="status">Status</th>
            </tr>
          </thead>

          <tbody class="table-list">
            <tr
              v-for="(item, itemIndex) in guardNotifications.list"
              :key="itemIndex"
              @click="selectItem(itemIndex)"
            >
              <td>{{ item.licencePlate.toUpperCase() }}</td>
              <td>{{ DateBR(item.createdAt) }}</td>
              <td>{{ item.creditCode }}</td>
              <td>[{{ item.parkCode }}] {{ item.parkName }}</td>
              <td>{{ totalToCurrencyBR(item.amountPaid) }}</td>
              <td>
                <span class="badge" :class="`badge${item.status}`">
                  {{ Status(item.status) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="btn-group paginatecontent"
      v-if="guardNotifications.countPages > 0"
    >
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
    <ModalDetails
      :show="isDetailsModalVisible"
      @close-modal="closeDetailsModal"
      :item="selectedItem"
      @goNext="goNextRegister"
      :count="countList"
      :currentItem="selectedItemIndex"
      @sendToSerpro="sendToSerpro"
      @refuse="refuse"
    />
  </div>
</template>
<script>
import ModalDetails from './modal-details/ModalDetails.vue';
import { toast } from '@/plugins/toast';

export default {
  components: {
    ModalDetails,
  },
  data() {
    return {
      isDetailsModalVisible: false,
      isExportSearchBusy: false,
      totalDocuments: 0,
      searchForm: {
        dateStart: 0,
        dateEnd: 0,
        creditCode: '',
        park: '',
        status: 1,
        page: 0,
        limit: 30,
      },
      guardNotifications: {
        countPages: 0,
        originalList: [],
        list: [],
      },
      parkingList: [],
      selectedItem: {},
      selectedItemIndex: -1,

    };
  },
  mounted() {
    this.loadGuardConfig();
    this.setInitialDate();
    this.listGuardNotifications();
    this.listParkings();
  },
  computed: {
    hasPageLeft() {
      return this.searchForm.page === 0;
    },
    hasPageRight() {
      return this.searchForm.page >= this.guardNotifications.countPages;
    },
    countList() {
      return this.guardNotifications.list.length;
    }
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
    Status(status) {
      switch (status) {
        case 0:
          return 'DISPONÍVEL';
        case 1:
          return 'PROCESSADO';
        case 2:
          return 'REMOVIDO';
      }
    },
    async loadGuardConfig() {
      await this.$store.dispatch('GUARD-REQUEST/GetGuardConfig');
    },
    setInitialDate() {
      this.searchForm.dateStart = new Date().toISOString().substr(0, 10);
      this.searchForm.dateEnd = new Date().toISOString().substr(0, 10);
    },
    async listGuardNotifications() {
      if (!this.checkDateRange()) return;
      this.guardNotifications.list = [];

      this.isExportSearchBusy = true;

      const dateStart = new Date(this.searchForm.dateStart + 'T03:00:00');
      const dateEnd = new Date(this.searchForm.dateEnd + 'T20:59:59');

      const payload = {
        ...this.searchForm,
        dateStart,
        dateEnd,
      };

      try {
        const guardNotifications = await this.$store.dispatch(
          'GUARD-REQUEST/ListGuardNotifications',
          payload,
        );

        const credits = guardNotifications.credits.map(i => ({
          ...i,
          isSelected: false,
        }));
        this.guardNotifications.list = credits;
        this.guardNotifications.countPages = guardNotifications.pages;
        this.totalDocuments = guardNotifications.totalDocuments;
      } catch (error) {
        toast.error('Não foi possível listar as solicitações');
      } finally {
        this.isExportSearchBusy = false;
      }
    },
    previousPage() {
      if (this.searchForm.page === 0) {
        return;
      }
      this.searchForm.page = this.searchForm.page - 1;
      this.listGuardNotifications();
    },
    nextPage() {
      if (this.searchForm.page + 1 >= this.guardNotifications.countPages) {
        return;
      }
      this.searchForm.page = this.searchForm.page + 1;
      this.listGuardNotifications();
    },
    async listParkings() {
      const parkingListFull = await this.$store.dispatch('PARKING/GetParkList');
      const parkingList = parkingListFull.map(item => ({
        id: item._id,
        parkName: item.parkName,
      }));
      this.parkingList = parkingList;
    },
    setDate(dt) {
      const date = new Date(dt);
      return date;
    },
    checkDateRange() {
      const isRangeValid = this.setDate(this.searchForm.dateStart) <= this.setDate(this.searchForm.dateEnd);
      if (!isRangeValid)toast.error('A data de início deve ser menor ou igual a data final');
      return isRangeValid;
    },
    closeDetailsModal(forceRefresh = false) {
      this.isDetailsModalVisible = false;
      if (forceRefresh) {
        this.listGuardNotifications();
      }
    },
    selectItem(item) {
      const register = this.guardNotifications.list[item]
      this.selectedItem = register;
      this.isDetailsModalVisible = true;
      this.selectedItemIndex = item;
    },
    goNextRegister() {
      if (this.selectedItemIndex + 1 < this.searchForm.limit) {
        this.selectedItemIndex = this.selectedItemIndex + 1;
        this.selectItem(this.selectedItemIndex);
      } else {
        toast.error('Você chegou ao último registro dessa página');
      }
    },
    sendToSerpro(payload) {
      this.$store.dispatch('SERPRO/SendToSerpro', payload)
    },
    refuse(payload) {
      this.$store.dispatch('SERPRO/RefuseAutuacao', payload)
    }
  },
};
</script>